module.exports = __webpack_public_path__ + "img/1498100605.431c1817.jpg";